import background1 from "../assets/image/background/background1.jpg";
import background2 from "../assets/image/background/background2.jpg";
import background3 from "../assets/image/background/background3.jpg";
import background4 from "../assets/image/background/background4.jpg";
import background5 from "../assets/image/background/background5.jpg";
import logo from "../assets/image/logo.png";
import error from "../assets/image/errors.svg";

import notification from "../assets/audio/notification.mp3";
export const notification_sound = notification;

// Export the backgrounds and logo
const assets = {
  backgrounds: [
    background1,
    background2,
    background3,
    background4,
    background5,
  ],
  logo,
  error,
};

export default assets;
